// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pG58","left":"styles_left__2n3gp","right":"styles_right___4rS2","alert":"styles_alert__2a0KJ"};